/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
const addLocaleData = require('react-intl').addLocaleData; //eslint-disable-line
const enLocaleData = require('react-intl/locale-data/en');
const deLocaleData = require('react-intl/locale-data/de');
const nlLocaleData = require('react-intl/locale-data/nl');
const plLocaleData = require('react-intl/locale-data/pl');

const enTranslationMessages = require('./translations/en.json');
const nlTranslationMessages = require('./translations/nl.json');
const deTranslationMessages = require('./translations/de.json');
const plTranslationMessages = require('./translations/pl.json');

addLocaleData(enLocaleData);
addLocaleData(nlLocaleData);
addLocaleData(deLocaleData);
addLocaleData(plLocaleData);

const DEFAULT_LOCALE = 'nl';

// prettier-ignore
const appLocales = [
  'nl',
  'en',
  'de',
  'pl'
];

const formatTranslationMessages = (locale, messages) => {
    console.log('!!! LOCALE !!!', locale, messages);
    const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  nl: formatTranslationMessages('nl', nlTranslationMessages),
  en: formatTranslationMessages('en', enTranslationMessages),
  de: formatTranslationMessages('de', deTranslationMessages),
  pl: formatTranslationMessages('pl', plTranslationMessages),
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
